import { Container, FormInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { AddictionType, AllergiesType, FoodIntolerancesType } from '../../../../types';

const AllergiesAndOthersInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);

  return (
    <Container>
      <FormInfoWrapper>
        <p>What is your request for help?</p>
        <em>{selectedClient?.requestForHelp?.description}</em>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <p>Food supplements</p>
        <em>{selectedClient?.foodSupplement?.content || 'None'}</em>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <p>Allergies</p>
        <div>
          {selectedClient?.allergies?.length ?
            selectedClient?.allergies.map((data: AllergiesType) => (
              <span key={data?.allergy?.id}>{data?.allergy?.name}</span>
            ))
            :
            <span>None</span>
          }
        </div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <p>Food intolerances</p>
        <div>
          {selectedClient?.foodIntolerances?.map((data: FoodIntolerancesType) => (
            <span key={data?.foodIntolerance?.id}>{data?.foodIntolerance?.name}</span>
          ))}
        </div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <p>Addictions</p>
        <div>
          {selectedClient?.addictions?.length ? (
            selectedClient?.addictions?.map((data: AddictionType) => (
              <span key={data?.addiction?.id}>{data?.addiction?.name}</span>
            ))
          ) : (
            <span>None</span>
          )}
        </div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <p>Cigarettes, Cigares per day</p>
        <div>
          <span>{selectedClient?.cigaretteConsumption?.frequency ?? 'None'}</span>
        </div>
      </FormInfoWrapper>
    </Container>
  )
}

export default AllergiesAndOthersInfo
